type WorksheetBatchUpdateEndpointConfiguration = {
  [type: string]: {
    /**
     * Endpoint for querying tests
     */
    queryEndpoint: string;
    /**
     * Name of property on response from this endpoint that is an array of tests.
     */
    responseTestsPropertyName: string;
    /**
     * Endpoint for updating tests in a batch
     * This is optional as some types cannot be updated via a test specific endpoint,
     * and can only have other operations performed (i.e. batch checking generic worksheets)
     */
    batchUpdateEndpoint?: string;
  };
};

const endpointConfiguration: WorksheetBatchUpdateEndpointConfiguration = {
  'Nuclear Field Density': {
    queryEndpoint: 'soil.nuclearFieldDensityTests.query',
    responseTestsPropertyName: 'NuclearFieldDensityTests',
    batchUpdateEndpoint: 'soil.nuclearFieldDensityTests.batchUpdate',
  },
  'Sand Replacement': {
    queryEndpoint: 'soil.sandReplacementTests.query',
    responseTestsPropertyName: 'SandReplacementTests',
    batchUpdateEndpoint: 'soil.sandReplacementTests.batchUpdate',
  },
  'Hand Shear Vane': {
    queryEndpoint: 'soil.handShearVaneTests.query',
    responseTestsPropertyName: 'HandShearVaneTests',
    batchUpdateEndpoint: 'soil.handShearVaneTests.batchUpdate',
  },
  'Relative Compaction': {
    queryEndpoint: 'soil.relativeCompactionTests.query',
    responseTestsPropertyName: 'RelativeCompactionTests',
    batchUpdateEndpoint: 'soil.relativeCompactionTests.batchUpdate',
  },
  'Dynamic Cone Penetrometer': {
    queryEndpoint: 'soil.dynamicConePenetrometerTests.query',
    responseTestsPropertyName: 'DynamicConePenetrometerTests',
    batchUpdateEndpoint: 'soil.dynamicConePenetrometerTests.batchUpdate',
  },
  Worksheet: {
    queryEndpoint: 'worksheets.query',
    responseTestsPropertyName: 'Worksheets',
  },
};
export default endpointConfiguration;
